/* © 2024 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { StyledRefreshIndicator } from './tableRefreshIndicatorStyles';
export var EmbersTableRefreshIndicator = function EmbersTableRefreshIndicator(props) {
  var lastUpdated = props.lastUpdated;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(StyledRefreshIndicator, {
    className: "EmbersTable-RefreshIndicator-root"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true,
    className: "icon-reload"
  }), /*#__PURE__*/React.createElement("span", {
    className: "EmbersTable-RefreshIndicator-lastUpdated"
  }, intl.formatMessage({
    id: 'embers.table.bottomControls.lastUpdated',
    defaultMessage: 'Last updated'
  }), ' ', lastUpdated));
};